// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"461849a8","453":"d9d6a0eb"}[chunkId] + ".chunk.js";
};